/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Insert_Surround_Music_Notes_DoubleInputs */



/**
* | output |
* | --- |
* | "Insert surround ♪♪ to all selected events" |
*
* @param {Shortcut_Keys_Desc_Insert_Surround_Music_Notes_DoubleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_insert_surround_music_notes_double = /** @type {((inputs?: Shortcut_Keys_Desc_Insert_Surround_Music_Notes_DoubleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Insert_Surround_Music_Notes_DoubleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inserer des notes de musique entourees ♪♪ pour tous les evenements selectionnes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Füge Surround ♪♪ zu allen ausgewählten Ereignissen hinzu")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci surround ♪♪ a tutti gli eventi selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить объемный звук ♪♪ ко всем выбранным событиям")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar sonido envolvente ♪♪ en todos los eventos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("为所有选定事件插入环绕音♪♪")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したすべてのイベントにサラウンド♪♪を挿入します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी चयनित इवेंट्स में सराउंड ♪♪ डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir som surround ♪♪ em todos os eventos selecionados")
	return /** @type {LocalizedString} */ ("Insert surround ♪♪ to all selected events")
});